import axios from 'axios'

export default {
  namespaced: true,
  state: {
    lista: [],
    filtroContaId: null,
    filtroDataInicial: '',
    filtroDataFinal: '',
    filtroTipoPeriodo: 'MOVIMENTO',
    filtroStatus: '',
    registroSelecionadoId: null,
    recarregarLista: false
  },
  getters: {
    LISTA: state => state.lista,
    FILTRO_CONTA_ID: state => state.filtroContaId,
    FILTRO_DATA_INICIAL: state => state.filtroDataInicial,
    FILTRO_DATA_FINAL: state => state.filtroDataFinal,
    FILTRO_TIPO_PERIODO: state => state.filtroTipoPeriodo,
    FILTRO_STATUS: state => state.filtroStatus,
    REGISTRO_SELECIONADO_ID: state => state.registroSelecionadoId,
    RECARREGAR_LISTA: state => state.recarregarLista
  },
  mutations: {
    SET_LISTA(state, payload) {
      state.lista = payload
    },
    SET_FILTRO_CONTA_ID(state, payload) {
      state.filtroContaId = payload
    },
    SET_FILTRO_DATA_INICIAL(state, payload) {
      state.filtroDataInicial = payload
    },
    SET_FILTRO_DATA_FINAL(state, payload) {
      state.filtroDataFinal = payload
    },
    SET_FILTRO_TIPO_PERIODO(state, payload) {
      state.filtroTipoPeriodo = payload || 'MOVIMENTO'
    },
    SET_FILTRO_STATUS(state, payload) {
      state.filtroStatus = payload
    },
    SET_REGISTRO_SELECIONADO_ID(state, payload) {
      state.registroSelecionadoId = payload
    },
    SET_RECARREGAR_LISTA(state, payload) {
      state.recarregarLista = payload
    },
    SET_LIMPAR(state) {
      state.filtroContaId = null
      state.filtroDataInicial = ''
      state.filtroDataFinal = ''
      state.filtroTipoPeriodo = 'MOVIMENTO'
      state.filtroStatus = ''
      state.registroSelecionadoId = null
    }
  },
  actions: {
    async GET_LISTA(context) {
      const params = {
        contaId: context.state.filtroContaId,
        dt1: context.state.filtroDataInicial,
        dt2: context.state.filtroDataFinal,
        tipoPeriodo: context.state.filtroTipoPeriodo,
        status: context.state.filtroStatus
      }

      const { data } = await axios.get('/api/protected/conferenciaFinanceira', { params })
      context.commit('SET_LISTA', data)
      return data
    }
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modulos/conferencia-financeira-store.js